<ng-container *ngIf="(isActive$ | async) === true; else inactive">
  <br />
  <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="16px">
    <button
      (click)="redirectToDashboardLink()"
      color="primary"
      gaEvent="open_stripe_dashboard"
      mat-raised-button
      type="button"
    >
      Mes virements
    </button>
    <button
      [routerLink]="'sales'"
      color="primary"
      gaEvent="open_sales"
      mat-raised-button
      type="button"
    >
      Mes ventes
    </button>
  </div>
</ng-container>
<ng-template #inactive>
  <ng-container *ngIf="(isActive$ | async) === false">
    <br />
    <button
      gaEvent="open_onboarding"
      type="button"
      mat-raised-button
      color="primary"
      (click)="redirectToOnboardingLink()"
    >
      Terminer mon adhésion
    </button>
  </ng-container>
</ng-template>
